export default {
  'traces.title': 'List of Traces',
  'traces.text.actor': 'Actor',
  'traces.text.IsSuccessFullOperation': 'Successful Operation',
  'traces.text.entity': 'Entity',
  'traces.text.entityDescription': 'Entity Description',
  'traces.text.environment': 'Environment',
  'traces.text.operation': 'Operation',
  'traces.text.entityId': 'Entity Identifier',
  'traces.text.isSuccessfulOperation': 'Is Successful Operation?',
  'traces.operation.add': 'Add',
  'traces.operation.addMany': 'Add Many',
  'traces.operation.update': 'Update',
  'traces.operation.updateMany': 'Update Many',
  'traces.operation.remove': 'Remove',
  'traces.operation.removeMany': 'Remove Many',
  'traces.operation.activate': 'Activate',
  'traces.operation.deactivate': 'Deactivate',
  'traces.operation.spCall': 'SP Call',
  'traces.operation.query': 'Query',
  'traces.actor.user': 'User',
  'traces.actor.system': 'System',
  'traces.actor.anonymoususer': 'Anonymous User',
  'traces.actor.rpaagent': 'RPA Agent',
  'traces.actor.processengine': 'Process Engine',
  'traces.actor.webhook': 'Webhook',
};
